@if (visible()) {
  <div class="hole-legend">
    @if (store.holeFeatureFilter() === 'all') {
      <div class="hole-legend__grid" [class.hole-legend__grid--ratio]="store.holeLegends().status[0]?.percentage !== undefined">
        @for (legend of store.holeLegends().status; track legend.holeStatus) {
          <div class="legend-box">
            <img [src]="statusIcon(legend.holeStatus)" [alt]="legend.holeStatus" />
            <div class="legend-box__text">
              @if (legend.percentage !== undefined) {
                <p>{{ 'HOLE.' + legend.holeStatus | translate }} - {{ legend.percentage }}%</p>
                <small>{{ legend.numberOfHoles }}/{{ legend.totalHoles || 0 }} holes</small>
              } @else {
                <p>{{ 'HOLE.' + legend.holeStatus | translate }} ({{ legend.numberOfHoles }})</p>
              }
            </div>
          </div>
        }
      </div>
    } @else {
      <div class="hole-legend__grid hole-legend__grid--ratio">
        @for (legend of store.holeLegends().feature; track legend.featureType) {
          <div class="legend-box">
            <img [src]="featureIcon(legend.featureType)" [alt]="legend.featureType" />
            <div class="legend-box__text">
              <p>{{ featureLabel(legend.featureType) }} - {{ legend.percentage }}%</p>
              <small>{{ legend.numberOfHoles }}/{{ legend.totalHoles || 0 }} holes</small>
            </div>
          </div>
        }
      </div>
    }
  </div>
}
